module.exports = __webpack_public_path__ + "img/logo-dark.6a738ecb.png";